<template>

<v-layout align-center justify-center row fill-height v-if="this.type === 'unknown'">
  <v-flex xs8>
    <b class="teal--text darken-1">Нажаль сервіс не може відобразити файл, збережіть його на вашому компьютері
      та скористуйтесь вашими вбудованими редакторами для відображення.</b>
  </v-flex>
</v-layout>
<v-layout v-else align-center justify-center row fill-height>
  <iframe v-if="this.type === 'office'" :src="url" width="100%" height="700px" frameborder="0"></iframe>
  <pdf v-if="this.type === 'pdf'" :url="url" height="700px"></pdf>
</v-layout>
</template>

<script>
import VuePDFViewer from 'vue-instant-pdf-viewer'

export default {
  props: ['document', 'is_shared'],
  components: {
    pdf: VuePDFViewer
  },
  data () {
    return {
      type: '',
      url: ''
    }
  },
  created () {
    let doc_name = this.document.name

    let token = '?access_token='+localStorage.getItem('token')
    if (this.is_shared) {
      token = ''
    }

    if (doc_name.endsWith('.xls') ||
        doc_name.endsWith('.xlsx') ||
        doc_name.endsWith('.doc') ||
        doc_name.endsWith('.docx')) {
      this.url = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(this.document.view_url + token)
      this.type = 'office'
    } else if (doc_name.endsWith('.pdf')) {
      this.url = this.document.view_url+token
      this.type = 'pdf'
    } else {
      this.type = 'unknown'
    }
  }
}
</script>